import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/left.png';
import _imports_1 from '@/assets/imgs/right.png';
import _imports_2 from '@/assets/modeImg/mode1.png';
import _imports_3 from '@/assets/modeImg/mode2.png';
import _imports_4 from '@/assets/modeImg/mode3.png';
import _imports_5 from '@/assets/modeImg/mode4.png';
import _imports_6 from '@/assets/modeImg/mode5.png';
import _imports_7 from '@/assets/modeImg/mode6.png';

const _withScopeId = n => (_pushScopeId("data-v-0fb4ccb7"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "exhibition"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "module-name"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "left-img"
}, null, -1));

const _hoisted_5 = {
  class: "name"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "right-img"
}, null, -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "支持渠道、直客双模式")], -1));

const _hoisted_8 = {
  class: "modeList"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "众多产品"), /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "丰富的产品库，产品全覆盖")])], -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "精细化客户管理"), /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "精细化客户管理，加速商机转化")])], -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "裂变获客工具"), /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "众多营销工具，助力业绩增长")])], -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "可视化业绩报表"), /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "业绩数据可视化，助力科学决策")])], -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "客户档案留存"), /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "员工离职，客户档案不流失")])], -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "提升工作效率"), /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "线索自动分配，业绩自动结算")])], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString($props.name), 1), _hoisted_6]), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_9]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_10]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_11]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_12]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_13]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_14]),
      _: 1
    })]),
    _: 1
  })])]);
}